<template>
    <v-sheet color="transparent" class="v-col-12 text-center pt-2 pb-5">
        <v-card-title class="pa-1 pa-md-4">
            <h1 class="text-md-h1 primary-text-color">{{ title }}</h1>
        </v-card-title>
    </v-sheet>
</template>

<script setup lang="ts">
import { IPageTitle } from '../../../types';

defineProps<IPageTitle>();
</script>
